import Image from '@base/FutureImage';
import styled from '@emotion/styled';
import { Fonts, Spacings } from '@styles/index';
import Tick from 'aquilla/icons/actions/Tick';
import Typography from 'aquilla/core/atoms/Typography';
import { commasIndianFormat } from '@utils/textHelper';
import PriceBreakDownTable from './PriceBreakDownTable';
import { getDescriptionArray } from './PlanDetailCard';

const AddonCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacings.SPACING_3B};
`;

const AddonTopWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${Spacings.SPACING_2B};
`;

const AddonBottomWrapper = styled.div<{ $showRadioButton: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${Spacings.SPACING_3B};
  padding-left: ${({ $showRadioButton }) => $showRadioButton && '18px'};
`;

const InfoPoints = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${Spacings.SPACING_2};
`;

const InfoPointsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacings.SPACING_6};
`;

const DiscountInfoBanner = styled.div`
  position: relative;
  display: flex;
  background-color: var(--color-i-green-18);
  border-radius: ${Spacings.SPACING_2B};
`;

const DiscountText = styled(Typography)`
  padding: ${Spacings.SPACING_3B};
  font-weight: ${Fonts.SEMIBOLD};
  color: var(--color-i-green-focus);
`;

const StyImageWrapper = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
`;

const AddonCard = ({
  showRadioButton = true,
  isChecked = false,
  onClick,
  priceBreakDown,
  title = '',
  skuDetails,
  comboDiscount,
  addonsMetaInfo = { iconicFeatures: {} }
}) => {
  const radioButtonUrl = `newPlanSelection/${
    isChecked ? 'StyRadioChecked' : 'StyRadioUnchecked'
  }.svg`;
  const { title: skuTitle = '' } = skuDetails ?? {};
  const addonsMetaArray = getDescriptionArray(addonsMetaInfo?.iconicFeatures);

  return (
    <>
      <AddonCardWrapper onClick={onClick}>
        {showRadioButton && (
          <AddonTopWrapper>
            <Image
              src={radioButtonUrl}
              width={24}
              height={24}
              alt="Radio Button"
            />
            <Typography variant="h5">{title}</Typography>
          </AddonTopWrapper>
        )}
        <AddonBottomWrapper $showRadioButton={showRadioButton}>
          {addonsMetaArray?.length !== 0 && (
            <InfoPointsWrapper>
              {addonsMetaArray?.map((metaInfo) => {
                return (
                  <InfoPoints key={metaInfo}>
                    <Tick
                      color="var(--color-i-gray-13)"
                      width={16}
                      height={16}
                    />
                    <Typography variant="p2" color="var(--color-i-gray-13)">
                      {metaInfo}
                    </Typography>
                  </InfoPoints>
                );
              })}
            </InfoPointsWrapper>
          )}
          <PriceBreakDownTable priceBreakDown={priceBreakDown} />
          <DiscountInfoBanner>
            <DiscountText variant="p3">
              You will save ₹{commasIndianFormat(comboDiscount)} when you
              purchase {title} & {skuTitle}!
            </DiscountText>
            <StyImageWrapper>
              <Image
                src="newPlanSelection/discountInfoBannerIcon.svg"
                width={24}
                height={24}
                alt="Referral Ticket"
              />
            </StyImageWrapper>
          </DiscountInfoBanner>
        </AddonBottomWrapper>
      </AddonCardWrapper>
    </>
  );
};

export default AddonCard;
